import { configureStore, combineReducers } from '@reduxjs/toolkit'
import { thunk } from 'redux-thunk'

import authReducer from './slices/authSlice'
import userReducer from './slices/userSlice'
import patientReducer from './slices/patientSlice'
import patientsReducer from './slices/patientsSlice'
import billingReducer from './slices/billingSlice'
import staffReducer from './slices/staffSlice'
import attendanceReducer from './slices/attendanceSlice'
import accountReducer from './slices/accountSlice'
import treatmentReducer from './slices/treatmentSlice'
import designationReducer from './slices/designationSlice'
import categoryReducer from './slices/categorySlice'
import dietReducer from './slices/dietSlice'
import hospitalReducer from './slices/hospitalSlice'

const reducer = combineReducers({
  authState: authReducer,
  userState: userReducer,
  patientState : patientReducer,
  patientsState : patientsReducer,
  billingState : billingReducer,
  staffState : staffReducer,
  attendanceState : attendanceReducer,
  accountState : accountReducer,
  treatmentState: treatmentReducer,
  designationState: designationReducer,
  categoryState: categoryReducer,
  dietState: dietReducer,
  hospitalState: hospitalReducer,
})

const store = configureStore({
  reducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      thunk
    })
})

export default store;